import { useCallback, useEffect } from 'react';
export var useKeyPress = function(targetKey, isValid, callback) {
    var handleKeyDown = useCallback(function(event) {
        if (event.key === targetKey && isValid) {
            callback();
        }
    }, [
        targetKey,
        isValid,
        callback
    ]);
    useEffect(function() {
        window.addEventListener('keydown', handleKeyDown);
        return function() {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown
    ]);
};
